// extracted by mini-css-extract-plugin
module.exports = {"modal_content":"DeleteModal_modal_content__knNqo"};